import { Button, Card, Group, Stack, Text, TextInput } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';

import { api } from '../api';
import { apiErrorMessage } from '../api/client';
import { AvatarUpload } from '../components/avatar-upload';
import { PageHeader } from '../components/page-header';
import { t } from '../dictionary';
import { useAuth } from '../providers/auth-context';

export const SettingsPage = () => {
    const { partner, setPartner } = useAuth();

    const [name, setName] = useState(partner.name);
    const [avatarUrl, setAvatarUrl] = useState<string | null>(partner.avatarUrl ?? null);
    const [saving, setSaving] = useState(false);

    const save = async () => {
        setSaving(true);

        try {
            const { data } = await api.updateMe({ name, avatarUrl });

            setPartner(data);
            setAvatarUrl(data.avatarUrl ?? null);
            notifications.show({ color: 'green', message: t.common.saved });
        } catch (error) {
            notifications.show({ color: 'red', message: apiErrorMessage(error) });
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <PageHeader title={t.settings.title} />

            <Card padding='lg' maw={520}>
                <Stack gap='md'>
                    <Text fw={650}>{t.settings.profile}</Text>

                    <AvatarUpload
                        value={avatarUrl}
                        name={name}
                        onChange={setAvatarUrl}
                        disabled={saving}
                    />

                    <TextInput
                        label={t.auth.fullName}
                        value={name}
                        onChange={(e) => setName(e.currentTarget.value)}
                    />

                    <TextInput
                        label={t.settings.email}
                        value={partner.email}
                        disabled
                        description={t.settings.emailNote}
                    />

                    <Group justify='flex-end'>
                        <Button loading={saving} onClick={save}>
                            {t.common.save}
                        </Button>
                    </Group>
                </Stack>
            </Card>
        </>
    );
};
